import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ConsultaAyudaMedicaService
{
    constructor(public http: HttpClient, ) { }
    verArchivo(idAyuda:any){
        return this.http.get(`${environment.urlApiAyudaMedica}/ayuda/${idAyuda}/archivo-adjunto/`,
        { headers:this.armaCabecera() }).toPromise()
    }
    verArchivoPostulacion(idPostulacion:any){
        return this.http.get(`${environment.urlApiAyudaMedica}/postulacion/${idPostulacion}/archivo-adjunto/`,
        { headers:this.armaCabecera() }).toPromise()
    }
    traeTipoEvento(){
        return this.http.get(`${environment.urlApiAyudaMedica}/getTipoEvento`,
               { headers: this.armaCabecera() }).toPromise();
    }
    traeProteccionSalud(){
        return this.http.get(`${environment.urlApiAyudaMedica}/getProteccionSalud`,
               { headers: this.armaCabecera() }).toPromise();
    }
    traeRegiones()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estadosSubsidios`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traePostulacion(idPostulacion:any){
        return this.http.post(`${environment.urlApiAyudaMedica}/obtener/postulacion/${idPostulacion}`,
        
        { headers:this.armaCabecera() }).toPromise()
    }
        traePostulacionesDisponibles(email: any, buscador?: any)
    {
        console.log("buscador",buscador);
        return this.http.post(`${environment.urlApiAyudaMedica}/postulaciones/ingresadas`,
        {
            email: email,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion:buscador?.region,
            rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estadoselect
        },
        { headers:this.armaCabecera() }).toPromise()
    }
    
    traePostulacionesAsignadas(idEjecutivo:any,buscador?:any)
    {
       
        return this.http.post(`${environment.urlApiAyudaMedica}/postulaciones/asignadas`,
        {
            idUsuarioAsig:idEjecutivo,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            idRegion:buscador?.region,
            //rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estadoselect
        },
        { headers:this.armaCabecera() }).toPromise() 
    }
    postulacionesAfiliado(email: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiAyudaMedica}/postulaciones/afiliado`,
        {
            email: email,
            idAfiliado: buscador?.idAfiliado,
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,

            
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
           
            idRegion:buscador?.region,
           // rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estadoselect
        },
        { headers:this.armaCabecera() }).toPromise() 
    }
    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
        console.log("postulaciones a enviar!!!",postulaciones)
        return this.http.post(`${environment.urlApiAyudaMedica}/postulacion/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }
    anularPostulacion(idPostulacion: any){
      
        return this.http.get(`${environment.urlApiAyudaMedica}/anular/postulacion/${idPostulacion}`,
       
        { headers:this.armaCabecera() }).toPromise();
    }
    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
